export default function authorProps() {
  return {
    __typename: {
      required: true,
      type: String,
    },
    byline: {
      default: null,
      type: String,
    },
    firstName: {
      required: true,
      type: String,
    },
    fullName: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
    photo: {
      default: null,
      type: Object,
    },
    role: {
      default: null,
      type: String,
    },
  };
}
